import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useLanguage } from '../context/LanguageContext';

const TermsPage = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col bg-black" data-testid="terms-page">
      <Header />
      
      <main className="flex-1 pt-20">
        {/* Hero */}
        <section className="bg-gradient-to-br from-gray-900 to-black py-16 px-4 border-b border-gray-800">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-black text-white mb-4">
              {language === 'nl' ? 'Algemene Voorwaarden' : 'Terms and Conditions'}
            </h1>
            <p className="text-gray-400">
              {language === 'nl' ? 'Laatst bijgewerkt: december 2025' : 'Last updated: December 2025'}
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 px-4 bg-black">
          <div className="max-w-3xl mx-auto prose prose-invert prose-rose">
            <h2 className="text-white">{language === 'nl' ? '1. Algemeen' : '1. General'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Deze algemene voorwaarden zijn van toepassing op het gebruik van het Swipe je woning platform en alle diensten die wij aanbieden. Door gebruik te maken van Swipe je woning gaat u akkoord met deze voorwaarden.'
                : 'These terms and conditions apply to the use of the Swipe je woning platform and all services we offer. By using Swipe je woning you agree to these terms.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '2. Swipe je woning Dienst' : '2. Swipe je woning Service'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Swipe je woning is een platform dat huurders en verhuurders samenbrengt door middel van een swipe-gebaseerd matching systeem. Wij faciliteren het contact maar zijn geen partij in eventuele huurovereenkomsten.'
                : 'Swipe je woning is a platform that connects tenants and landlords through a swipe-based matching system. We facilitate contact but are not a party to any rental agreements.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '3. Accountregistratie' : '3. Account Registration'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Om gebruik te maken van Swipe je woning moet u een account aanmaken met correcte gegevens. U bent verantwoordelijk voor het vertrouwelijk houden van uw inloggegevens.'
                : 'To use Swipe je woning you must create an account with correct information. You are responsible for keeping your login details confidential.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '4. Gebruik van de dienst' : '4. Use of the Service'}</h2>
            <p className="text-gray-400">{language === 'nl' ? 'U stemt ermee in om:' : 'You agree to:'}</p>
            <ul className="text-gray-400">
              <li>{language === 'nl' ? 'Alleen waarheidsgetrouwe informatie te verstrekken' : 'Only provide truthful information'}</li>
              <li>{language === 'nl' ? 'De dienst niet te gebruiken voor illegale doeleinden' : 'Not use the service for illegal purposes'}</li>
              <li>{language === 'nl' ? 'Geen spam of misleidende berichten te versturen' : 'Not send spam or misleading messages'}</li>
              <li>{language === 'nl' ? 'Respectvol te communiceren met andere gebruikers' : 'Communicate respectfully with other users'}</li>
              <li>{language === 'nl' ? 'Geen valse profielen aan te maken' : 'Not create fake profiles'}</li>
            </ul>

            <h2 className="text-white">{language === 'nl' ? '5. Abonnement' : '5. Subscription'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Het Swipe je woning abonnement kost €4,99 per week en wordt wekelijks gefactureerd. U kunt op elk moment opzeggen via uw dashboard. Na opzegging heeft u toegang tot het einde van de betaalperiode.'
                : 'The Swipe je woning subscription costs €4.99 per week and is billed weekly. You can cancel at any time via your dashboard. After cancellation, you have access until the end of the billing period.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '6. Matching & Berichten' : '6. Matching & Messages'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Wanneer u een woning "liked", wordt uw profiel en automatisch bericht gedeeld met de verhuurder. U gaat akkoord met het delen van deze informatie voor het matching-proces.'
                : 'When you "like" a property, your profile and automatic message are shared with the landlord. You agree to sharing this information for the matching process.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '7. Aansprakelijkheid' : '7. Liability'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Swipe je woning faciliteert contact tussen huurders en verhuurders maar is geen partij in de huurovereenkomst. Wij zijn niet aansprakelijk voor geschillen tussen gebruikers of voor de kwaliteit van aangeboden woningen.'
                : 'Swipe je woning facilitates contact between tenants and landlords but is not a party to the rental agreement. We are not liable for disputes between users or for the quality of offered properties.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '8. Wijzigingen' : '8. Changes'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Wij behouden het recht om deze voorwaarden te wijzigen. Belangrijke wijzigingen worden gecommuniceerd via e-mail.'
                : 'We reserve the right to change these terms. Important changes will be communicated via email.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '9. Contact' : '9. Contact'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Voor vragen over deze voorwaarden kunt u contact opnemen via legal@swipejewoning.nl.'
                : 'For questions about these terms, you can contact us at legal@swipejewoning.nl.'}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;
